// extracted by mini-css-extract-plugin
module.exports = {"box":"about-module--box--2NIjC","boxSmall":"about-module--boxSmall--1ONLo","blockquote":"about-module--blockquote--2N9ep"};